import { render, staticRenderFns } from "./mmTable.vue?vue&type=template&id=20712077"
import script from "./mmTable.vue?vue&type=script&lang=js"
export * from "./mmTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports